import PermissionChecker from '@/security/permission-checker';
import Permissions from '@/security/permissions';

export class AccountsPermissions {
    constructor(currentUser) {
        const permissionChecker = new PermissionChecker(
            currentUser,
        );

        this.read = permissionChecker.match(
            Permissions.values.accountsRead,
        );
        this.create = permissionChecker.match(
            Permissions.values.accountsCreate,
        );
        this.edit = permissionChecker.match(
            Permissions.values.accountsEdit,
        );
        this.destroy = permissionChecker.match(
            Permissions.values.accountsDestroy,
        );
    }
}
